import { citySeoPages } from './seoCityPages';
import { brandSeoPages } from './seoBrandPages';
import { problemSeoPages } from './seoProblemPages';
import { b2bSeoPages } from './seoB2BPages';
import { companyInfo, conversionImages, faqs } from './mockData';

export const SITE_ORIGIN = process.env.REACT_APP_SITE_URL;
if (!SITE_ORIGIN) throw new Error('REACT_APP_SITE_URL is required');

export const homeSeo = {
  path: '/', canonical: `${SITE_ORIGIN}/`,
  title: '3D Printer Repair Australia | 3D Printer Gear',
  description: 'Australia-wide 3D printer repair and maintenance for Bambu Lab, Prusa, Creality and more. Send-in repairs, school fleet support and a quote before work begins.',
  h1: 'Get your 3D printer repaired by specialists',
  image: conversionImages.heroRepairTechnician,
  faqs,
};

export const publicPages = [
  homeSeo,
  ...Object.values(citySeoPages), ...Object.values(brandSeoPages),
  ...Object.values(problemSeoPages), ...Object.values(b2bSeoPages),
  {
    path: '/apply-as-technician', canonical: `${SITE_ORIGIN}/apply-as-technician`,
    title: 'Apply as a 3D Printer Technician | 3D Printer Gear Contractor Network',
    h1: 'Apply as a 3D Printer Technician', image: companyInfo.logo,
    description: 'Apply to join the 3D Printer Gear contractor technician network for qualified 3D printer repair, maintenance, school and business service opportunities across Australia.',
  },
  {
    path: '/book-service', canonical: `${SITE_ORIGIN}/book-service`,
    title: 'Book a 3D Printer Repair | 3D Printer Gear', h1: 'Book a 3D printer repair',
    description: 'Request a 3D printer repair quote. Share your printer model, symptoms, location and optional photos or videos with the 3D Printer Gear service team.',
    image: conversionImages.heroRepairTechnician,
  },
];

export const normalizePath = (path) => path.replace(/\/+$/, '') || '/';
export const getPageSeo = (path) => publicPages.find((page) => page.path === normalizePath(path)) || {
  path: '/404', title: 'Page not found | 3D Printer Gear',
  description: 'This page could not be found. Browse 3D Printer Gear repair services or contact the service team.',
  image: conversionImages.heroRepairTechnician, robots: 'noindex, follow',
};